// Set the public path of chunks to the main bolt app path
__webpack_public_path__ = `${window.boltBase}/bolt-main/app/` // eslint-disable-line no-undef
